export default __webpack_public_path__ + "maps-examples-point-conversion-thumbnail-480-c8f39eaafaa8a04b1cdf9c159651c9dc.png";